"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PromotionAreaBinding_1 = require("../model/PromotionAreaBinding");

var PromotionAreaBindingConverter_1 = require("./PromotionAreaBindingConverter");
/**
 * Implementation of {@link PromotionAreaBindingConverter}
 * @author OPt
 */


var PromotionAreaBindingConverterImpl =
/*#__PURE__*/
function (_PromotionAreaBinding) {
  _inherits(PromotionAreaBindingConverterImpl, _PromotionAreaBinding);

  function PromotionAreaBindingConverterImpl() {
    _classCallCheck(this, PromotionAreaBindingConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionAreaBindingConverterImpl).apply(this, arguments));
  }

  _createClass(PromotionAreaBindingConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new PromotionAreaBinding_1.PromotionAreaBinding(PromotionAreaBinding_1.PromotionAreaBinding.schema.id.valueOf(conversions.documentToClassId(source)), PromotionAreaBinding_1.PromotionAreaBinding.schema.promotionId.valueOf(conversions.toClassReferenceId(source.promotionId)), PromotionAreaBinding_1.PromotionAreaBinding.schema.promotionAreaId.valueOf(conversions.toClassReferenceId(source.promotionAreaId)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        promotionId: conversions.toDocumentReferenceId(source.promotionId),
        promotionAreaId: conversions.toDocumentReferenceId(source.promotionAreaId)
      });
      return result;
    }
  }]);

  return PromotionAreaBindingConverterImpl;
}(PromotionAreaBindingConverter_1.PromotionAreaBindingConverter);

exports.PromotionAreaBindingConverterImpl = PromotionAreaBindingConverterImpl;